import { START_VIEW_STATS } from '../types';

export const showStats = (menu_id, foreign_id) => ({
  type: START_VIEW_STATS,
  payload: { menu_id, foreign_id },
});
